// TODO: Revisit

import PropTypes from 'prop-types';
import { useContext, useMemo, useRef } from 'react';
import * as yup from 'yup';
import AuthContext from 'context/authContext';
import CrudCard from '../../common/CrudCard/CrudCard';
import { getCountriesOptions } from 'data/options/countris-and-cities';
import {
  useLocations,
  useCreateLocation,
  useUpdateLocation,
  useDeleteLocation
} from 'hooks/useDonationSettings';

// import LocationsModal from './LocationsModal';

export const locationTypesMap = {
  project: 'Project',
  sponsorship: 'Sponsorship'
};

/* -------------------------------------------------------------------------- */
function Locations({ sectionRef, sideNavLink, type, subject }) {
  const cardRef = useRef();
  const { organization } = useContext(AuthContext);

  // const [isLocationsModalOpen, setIsLocationsModalOpen] = useState(false);

  const { locations, isLoading: loading } = useLocations(type);
  const { createLocation, isCreating: createLoading } = useCreateLocation();
  const { updateLocation, isUpdating: updateLoading } = useUpdateLocation();
  const { deleteLocation, isDeleting: deleteLoading } = useDeleteLocation();

  const handleCreate = async (data) => {
    try {
      await createLocation({
        location_name: data.location_name,
        type,
        organisation_id: organization.id
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (data) => {
    try {
      await updateLocation({
        id: data.id,
        data: { location_name: data.data.location_name }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteLocation(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const list = locations?.map(location => ({
    id: location.id,
    isOrgLevel: !location.branch_id,
    values: [
      {
        value: location.location_name,
        name: 'location_name'
      }
    ]
  }));

  const countriesOptions = useMemo(() => getCountriesOptions(), []);

  return (
    <>
      <CrudCard
        ref={cardRef}
        sectionRef={sectionRef}
        sideNavLink={sideNavLink}
        createData={handleCreate}
        loading={loading}
        editData={handleEdit}
        deleteData={handleDelete}
        createLoading={createLoading}
        updateLoading={updateLoading}
        deleteLoading={deleteLoading}
        formTitle={'Add Locations'}
        listTitle={'Current Locations'}
        title={`${type} Locations`}
        inputs={[
          {
            name: 'location_name',
            placeholder: `Add ${type} Location`,
            type: 'select',
            // hasAddOption: true,
            // onClickAdd: () => setIsLocationsModalOpen(true),
            required: true,
            value: '',
            validation: yup.string().required('Location name is required'),
            options: countriesOptions
          }
        ]}
        list={list}
        subject={subject}
      />
      {/*{isLocationsModalOpen && (*/}
      {/*  <LocationsModal*/}
      {/*    show={isLocationsModalOpen}*/}
      {/*    onClose={() => setIsLocationsModalOpen(false)}*/}
      {/*  />*/}
      {/*)}*/}
    </>
  );
}

Locations.propTypes = {
  sectionRef: PropTypes.string,
  sideNavLink: PropTypes.string,
  type: PropTypes.string,
  subject: PropTypes.string
};

export default Locations;
